// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#info-block{width:inherit}#info-block .section-info-head{display:flex;align-items:center;justify-content:space-between;margin-bottom:20px}#info-block .section-info-head .section-info-title{color:#333333;font-size:18px;font-family:\"HelveticaNeuyeCyr-Roman\",\"Helvetica\",sans-serif;font-weight:400}\n", ""]);
// Exports
module.exports = exports;
